// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1uNut","colCheckbox":"styles_colCheckbox__yL67W"};